import styled from '@emotion/styled'
import { Paper } from '@mui/material'

export const Block = styled(Paper)(({ theme }) => ({
    marginBottom: '16px',
    padding: '32px 24px',
    backgroundColor: '#fff',
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}))
